// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { subYears as fn } from "../subYears.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const subYears = convertToFP(fn, 2);

// Fallback for modularized imports:
export default subYears;
